export default __webpack_public_path__ + "static/media/primera.4daea006.png";